import { EnumBase } from 'hay-core-react';
class PesquisaExecucaoLogTipoExecucaoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.pesquisaexecucaolog.tipoexecucao.automatico',
                'main.pesquisaexecucaolog.tipoexecucao.manual',
            ],
            'main.pesquisaexecucaolog.tipoexecucao.automatico'
        );
    }
}

const instance = new PesquisaExecucaoLogTipoExecucaoEnum();
export default instance;
